import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  assessmentsListRequest,
  assessmentsListSuccess,
  assessmentsListFailure,
} from '../reducers/contentList';
import { authUserFailure, logoutUserRequest } from '../reducers/login';
import { API_LINK } from '../../constants';
import {selectedProgram, selectedProgramId, selectedassessmentsId, selectedassessments, selectedVersionId, getSelectedThinktool} from '../selectors'
import { setExtensions } from '../reducers/userProgramsFull';

const API = `${API_LINK}api/user`;

function* assessmentsListAxios() {
  const state = yield select(fullState => fullState);
  const { selectedProgramId, selectedModuleId } = state.userProgramsFullReducer;
  const {   user: { userId },
  token } = state.loginReducer;

  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}/${userId}/allAssessments?program_id=${selectedProgramId}`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'assessments-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
    }),
  );

  return response;
}

function* workerAssessmentsListSaga() {
  try {
   
    const response = yield call(assessmentsListAxios);

    const responseFromassessmentsList = response.data;
    
    yield put(assessmentsListSuccess(responseFromassessmentsList.data.components[0].content));
    
    if(responseFromassessmentsList.data.components[0].content.length>0){
     
      if( responseFromassessmentsList.data.components[0].content[0].extensions_left){
        
        yield put(setExtensions(responseFromassessmentsList.data.components[0].content[0].extensions_left))
      }
     
    }
    if (response.status === 500) {
      yield put(authUserFailure(response));
    }
  } catch (error) {
   // yield put(logoutUserRequest());
    yield put(assessmentsListFailure(error.response));
  }
}

export function* watcherAssessmentsListSaga() {
  yield takeLatest(assessmentsListRequest().type, workerAssessmentsListSaga);
}
